// extracted by mini-css-extract-plugin
export var divider = "_t2-0";
export var systemMessage = "_t2-1";